import {doc} from '../docs.js';
import {hullFromArray} from "effects/midi/mappable/convexHull.js"
import {listSpline} from 'effects/midi/mappable/spline.js';
import * as THREE from 'three';

doc(
    "spline",
    {
        tension: "",
        points: ""
    },
    "Returns cubic spline",
    undefined,
    {
        tags: "Graphics",
        inlets: 3
    });

const objList = (l) => {
    let out = [];
    for (let i=0; i < l.length; i+=2) {
        out.push({x: l[i], y: l[i+1]});
    }
    return out;
};
export const spline = (object, tension, points) => {
    let knots = [];
    let curve = undefined;
    let _pts = [];
    let arr;
    return ([pts]) => {
        if (ArrayBuffer.isView(pts) || Array.isArray(pts)) {
            _pts.length = 0;
            for (let i=0; i < pts.length; i += 2) {
                _pts.push(new THREE.Vector3(pts[i], pts[i+1], 0));
            }
            if (!curve) {
                curve = new THREE.CatmullRomCurve3(_pts, true, "catmullrom", tension() || 1);
            } else {
                curve.tension = tension() || 1;
                curve.points = _pts;
            }
            let curvePts = curve.getPoints(points() || 150);
            let ct=0;

            if (!arr || curvePts.length * 2 !== arr.length) {
                arr = new Float32Array(curvePts.length*2);
            }
            for (let pt of curvePts) {
                arr[ct++] = pt.x;
                arr[ct++] = pt.y;
            }
            return arr;

            /*
            let splined = listSpline(objList(Array.from(pts)), tension() || .2);
            pts = splined;
            _pts.length = 0;
            for (let i=0; i < pts.length; i+=2) {
                _pts.push([pts[i], pts[i+1]]);
            }
            if (_pts[0]) {
                _pts.push(_pts[0]);
            }
            if (_pts[1]) {
                _pts.push(_pts[1]);
            }
            if (_pts[2]) {
                _pts.push(_pts[2]);
            }

            let len = _pts.length + 2 + 1;
            var maxT = 1.0 - 1.0 / len;
            let ctr=0;
            for (let t=0; t < 1; t+=0.01) {
                var point = bspline(t*maxT, 2, _pts);
                if (!isNaN(point[0]) && !isNaN(point[0])) {
                    arr[ctr++] = point[0];
                    arr[ctr++] = point[1];
                } 
            }
            */
        }
        return [arr];
    };
};

doc(
    "convexHull",
    {
    },
    "Returns convex hull as Float32Array of pts"
);

export const convexHull = () => {
    return ([pts]) => {
        let hull = hullFromArray(pts);
        return [hull];
    };
};

